import * as ProgressPrimitive from '@radix-ui/react-progress';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import {
  progressVariants,
  progressIndicatorVariants,
} from '@/shared/constants/ui-variants';
import { cn } from '@/shared/lib/utils';

export interface ProgressProps
  extends
    React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root>,
    VariantProps<typeof progressVariants> {
  readonly variant?: VariantProps<typeof progressIndicatorVariants>['variant'];
}

const Progress = React.forwardRef<
  React.ComponentRef<typeof ProgressPrimitive.Root>,
  ProgressProps
>(({ className, value, size, variant, ...props }, ref) => {
  const clampedValue = React.useMemo(() => {
    if (value === undefined || value === null) return 0;
    return Math.min(Math.max(value, 0), 100);
  }, [value]);

  return (
    <ProgressPrimitive.Root
      ref={ref}
      className={cn(progressVariants({ size }), className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        className={cn(progressIndicatorVariants({ variant }))}
        style={{ transform: `translateX(-${100 - clampedValue}%)` }}
      />
    </ProgressPrimitive.Root>
  );
});
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
export { ProgressSize, ProgressVariant } from '@/shared/types/progress.types';
